import { Flex, Skeleton } from 'front-commons/ds/components';

export function TriggerPlaceholder() {
	return (
		<Flex gap="8px" direction="column" margin="2px 0 0" width="218px">
			<Flex display={{ small: 'none', medium: 'flex' }}>
				<Skeleton width="143.66px" height="14px" />
			</Flex>

			<Skeleton height="16px" width="117.55px" />
		</Flex>
	);
}
